import { gql, useQuery } from '@apollo/client';

export const ACTION_LOG_FIELDS = gql`
  fragment ActionLogFields on ActionLog {
    id
    createdAt
    userId
    userEmail
    userName
    companyId
    action
    resourceType
    resourceId
    resourceName
    beforeState
    afterState
    automated
    metadata
    seen
  }
`;

export const GET_ACTION_LOGS = gql`
  ${ACTION_LOG_FIELDS}
  query GetActionLogs(
    $startDate: String
    $endDate: String
    $action: String
    $resourceType: String
    $userId: String
    $limit: Int
    $offset: Int
    $forNotifications: Boolean
  ) {
    actionLogs(
      startDate: $startDate
      endDate: $endDate
      action: $action
      resourceType: $resourceType
      userId: $userId
      limit: $limit
      offset: $offset
      forNotifications: $forNotifications
    ) {
      ...ActionLogFields
    }
  }
`;

export interface ActionLog {
  id: string;
  createdAt: string;
  userId?: string | null;
  userEmail: string;
  userName?: string;
  companyId: string;
  action: string;
  resourceType: string;
  resourceId: string;
  resourceName?: string;
  beforeState?: any;
  afterState?: any;
  automated: boolean;
  metadata?: any;
  seen: boolean;
}

export interface GetActionLogsResult {
  actionLogs: ActionLog[];
}

export interface ActionLogsQueryVariables {
  startDate?: string;
  endDate?: string;
  action?: string;
  resourceType?: string;
  userId?: string;
  limit?: number;
  offset?: number;
  forNotifications?: boolean;
}

export function useActionLogsQuery(variables?: ActionLogsQueryVariables) {
  return useQuery<GetActionLogsResult, ActionLogsQueryVariables>(GET_ACTION_LOGS, {
    variables,
    fetchPolicy: 'network-only',
    skip: !variables, // Skip query if no variables provided
    notifyOnNetworkStatusChange: true,
  });
}
